<template>
  <v-container fluid>
    <v-row class="mb-4">
      <v-col cols="6">
        <h3 class="title font-weight-bold">สร้างบทความใหม่</h3>
      </v-col>
      <v-col cols="6" class="text-right">
        <v-btn color="primary" depressed @click="onSubmit('published')"
          >เผยแพร่บทความนี้</v-btn
        >
      </v-col>
    </v-row>

    <v-row class="mb-4">
      <v-col cols="12" :md="8">
        <el-card class="box-card">
          <el-form
            :label-position="`top`"
            ref="form"
            :model="form"
            label-width="150px"
          >
            <el-form-item label="ประเภท">
              <el-select
                v-model="form.post_type"
                placeholder="please select post type"
                @change="onPostTypeChanged"
              >
                <el-option label="Blog" value="blog"></el-option>
                <!--
                <el-option label="Route" value="route"></el-option>
                <el-option label="Guide" value="guide"></el-option>
                -->
              </el-select>
            </el-form-item>
            <el-form-item label="ชื่อบทความ">
              <el-input v-model="form.post_title"></el-input>
            </el-form-item>
            <!--
            <el-form-item label="Post Slug">
              <el-input v-model="form.post_slug"></el-input>
            </el-form-item>
            -->
            <el-form-item label="คำนำ">
              <el-input
                type="textarea"
                rows="3"
                v-model="form.post_excerpt"
              ></el-input>
            </el-form-item>
            <el-form-item label="เนื้อหา">
              <ckeditor
                style="height:600px;"
                :editor="editor"
                v-model="form.post_content"
                :config="editorConfig"
              ></ckeditor>
            </el-form-item>
          </el-form>
        </el-card>
      </v-col>
      <v-col cols="12" :md="4" class="pl-3">
        <el-card class="box-card">
          <div class="mb-2">
            <strong>รูปภาพหน้าปก</strong>
          </div>
          <el-upload
            class="avatar-uploader"
            :action="deliveryApiDomain + `/cms/upload_media`"
            :name="`media`"
            :show-file-list="false"
            :on-success="handleSuccess"
            :before-upload="beforeUpload"
          >
            <img v-if="imageUrl" :src="form.featured_images" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>

          <template v-if="form.post_attributes_json != null">
            <template v-if="form.post_type == 'route'">
              <el-form
                :label-position="`top`"
                ref="form"
                :model="form"
                label-width="150px"
              >
                <el-form-item label="เส้นทาง">
                  <el-select
                    class="input-block mb-2"
                    v-model="form.post_attributes_json.route[0].name"
                    placeholder="select origin"
                  >
                    <el-option label="Bangkok" value="bangkok"></el-option>
                    <el-option label="Chiang Mai" value="route"></el-option>
                    <el-option label="Krabi" value="guide"></el-option>
                  </el-select>
                  <el-select
                    class="input-block"
                    v-model="form.post_attributes_json.route[1].name"
                    placeholder="select destination"
                  >
                    <el-option label="Bangkok" value="blog"></el-option>
                    <el-option label="Chiang Mai" value="route"></el-option>
                    <el-option label="Krabi" value="krabi"></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </template>
            <template v-if="form.post_type == 'guide'"></template>
          </template>
        </el-card>
      </v-col>
    </v-row>

    <v-dialog
      v-model="publishDialog"
      persistent
      transition="dialog-bottom-transition"
      width="700"
    >
      <v-card>
        <v-toolbar dark color="secondary">
          <v-toolbar-title>Publish this post</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark text @click="publishDialog = false">
              <v-icon>fas fa-times</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container fluid>
          <div>
            <div class="mb-2">
              <strong>Select Channel</strong>
            </div>
            <el-checkbox-group v-model="form.post_published_to">
              <el-checkbox label="hlz-web"></el-checkbox>
              <el-checkbox label="hlz-app"></el-checkbox>
              <el-checkbox label="halalroute"></el-checkbox>
              <el-checkbox label="halalhero"></el-checkbox>
            </el-checkbox-group>
          </div>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <el-button size="small" @click="onSubmit('draft')"
            >Save as Draft</el-button
          >
          <el-button type="danger" size="small" @click="onSubmit('published')"
            >Publish Now</el-button
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import Service from "@/services";
import { deliveryApiDomain } from "@/utils/Constants";

export default {
  components: {},
  data() {
    return {
      deliveryApiDomain: deliveryApiDomain,
      publishDialog: false,
      editor: ClassicEditor,
      editorData: "<p>Rich-text editor content.</p>",
      editorConfig: {
        toolbar: [
          "heading",
          "|",
          "bold",
          "italic",
          "link",
          "bulletedList",
          "numberedList",
          "blockQuote",
        ],
        // The configuration of the rich-text editor.
      },
      imageUrl: "",
      form: {
        ent_id: 12,
        post_status: "draft",
        post_type: "blog",
        post_title: "",
        post_slug: "",
        post_excerpt: "",
        post_content: "",
        post_attributes_json: null,
        post_categories_json: "",
        featured_images: "",
        post_published_to: [],
      },
    };
  },
  created() {},
  methods: {
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("Avatar picture must be JPG format!");
      }
      if (!isLt2M) {
        this.$message.error("Avatar picture size can not exceed 2MB!");
      }
      return isJPG && isLt2M;
    },
    handleSuccess(res, file) {
      //this.imageUrl = URL.createObjectURL(file.raw);
      this.imageUrl = res.data.path;
      this.form.featured_images = res.data.path;
    },
    onPostTypeChanged() {
      let attributes = {};
      if (this.form.post_type == "route") {
        attributes = {
          route: [
            { name: "จุดเริ่มต้น", coords: null },
            { name: "จุดหมายปลายทาง", coords: null },
          ],
        };
        this.form = { ...this.form, post_attributes_json: attributes };
      }
    },
    onSubmit(status) {
      this.showLoading();
      this.form.post_status = status;
      this.form.post_slug = this.form.post_title;
      Service.Cms.createPost(this.form)
        .then((res) => {
          this.hideLoading();
          this.$router.push("/posts");
        })
        .catch((e) => {
          this.hideLoading();
        });
    },
    showLoading() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)",
      });
    },
    hideLoading() {
      this.loading.close();
    },
  },
};
</script>
